import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RirekishoLicense } from '@src/api/core/api-types';

const initialState: RirekishoLicense[] = [];

const rirekishoLicenseSlice = createSlice({
  name: 'rirekishoLicense',
  initialState,
  reducers: {
    updateRirekishoLicense(_state, action: PayloadAction<RirekishoLicense[]>) {
      return action.payload;
    },
    addRirekishoLicenseItem(state, action: PayloadAction<RirekishoLicense>) {
      state.push(action.payload);
    },
    updateRirekishoLicenseItem(
      state,
      action: PayloadAction<{ index: number; item: Partial<RirekishoLicense> }>
    ) {
      const { index, item } = action.payload;
      if (state[index]) {
        state[index] = { ...state[index], ...item };
      }
    },
    removeRirekishoLicenseItem(state, action: PayloadAction<number>) {
      state.splice(action.payload, 1);
    },
  },
});

export const {
  updateRirekishoLicense,
  addRirekishoLicenseItem,
  updateRirekishoLicenseItem,
  removeRirekishoLicenseItem,
} = rirekishoLicenseSlice.actions;

export default rirekishoLicenseSlice.reducer;
